import styled, { css } from 'styled-components';
import { pxToRem } from '../../../design-tokens/style-utilities';
/**
 * Form Field Color Picker Container
 */
export const formFieldColorPickerContainerStyles = ({ theme }) => css `
	display: flex;
	flex-wrap: wrap;
	justify-content: flex-start;

	/* specificity is needed to overwrite *:last-child styling in panel-content.styled.ts */
	&& {
		margin-top: ${pxToRem(theme.spacing['400'])};
	}

	row-gap: ${pxToRem(theme.spacing['200'])};
`;
export const FormFieldColorPickerContainer = styled.div `
	${formFieldColorPickerContainerStyles}
`;
